import React, {useContext, useEffect, useRef, useState} from "react";
import {UserContext} from "../common/UserContext";
import {BrandContext} from "../common/BrandContext";
import {ContentContext} from "../common/ContentContext";
import axios from "../common/axios";
import {PageMarkerNavigation} from "./PageMarkerNavigation";
import NavAccessibilityWrap from "./NavAccessibilityWrap";
import CircularLoader from "../common/CircularLoader";
import ResourceNavigationDevelopment from "./ResourceNavigationDevelopment";
import CMSResourceNavigation from "./CMSResourceNavigation";
import {TemplateContext} from "../common/TemplateContext";
import Button from "../common/Button";
import {CrossIcon} from "../common/icons";
import {useScreenMode} from "../common/context/ScreenModeContext";

const NavigationRightDevelopment = props => {
    const {compressed, showResources = true, callback, children, closeNav} = props;
    const {user, updateRightMenuClosed} = useContext(UserContext);
    const brandConfig = useContext(BrandContext);
    const {content} = useContext(ContentContext);
    const [resourceGroups, setResourceGroups] = useState([]);
    const [isLoading, setLoading] = useState(true);
    const {shortcutLocation, navigationLinks} = useContext(TemplateContext);
    const closeButtonRef = useRef(null);
    const {smallScreenMode} = useScreenMode();

    const loadResources = (conceptId) => {
        setLoading(true);
        axios.get('/web/ui/content/concept/resources', {params: {conceptId: conceptId}})
            .then(response => {
                setResourceGroups(response.data);
            }).catch(e => {
            console.error('Error loading resources', e);
        }).finally(() => {
            setLoading(false);
        });
    }

    useEffect(() => {
        if(user.publicSession || user.expired) {
            return;
        }

        if (!compressed && smallScreenMode) {
            updateRightMenuClosed(true);
        } else if (brandConfig.rightMenuOpen) {
            updateRightMenuClosed(false);
        }
    }, [smallScreenMode]);

    useEffect(() => {
        if(content.currentConcept !== undefined) {
            loadResources(content.currentConcept.conceptId);
        } else {
            setLoading(false);
        }
    }, [content]);


    useEffect(() => {
        // Set focus when tabbing from small screen button
        // Using a timeout to give the component time to render
        if (smallScreenMode) {
            const timer = setTimeout(() => {
                if (closeButtonRef.current) {
                    closeButtonRef.current.focus();
                }
            }, 200);

            return () => clearTimeout(timer);
        }
    }, [smallScreenMode]);

    if ((user.publicSession && !user.guideMode) || user.expired) {
        return null;
    }

    if(isLoading) {
        return <div className={'ch-nav-lesson ch-nav-lesson-loader'}><CircularLoader pageCentered={true} displayInElement={true}/></div>;
    }

    if(smallScreenMode && !resourceGroups.some(resource => resource.resources) && (!navigationLinks || navigationLinks.length == 0)) return (
        <div className={'ch-nav-lesson'}>
            <div className={'ch-nav-lesson-title-wrapper'}>
                <Button type={'outline'} ref={closeButtonRef} onClick={() => closeNav()} aria-label={'Close'}><CrossIcon /></Button>
            </div>
            <p>No shortcuts or resources for this page.</p>
        </div>
    );

    if(!resourceGroups.some(resource => resource.resources) && (!navigationLinks || navigationLinks.length == 0)) return null;


    return (
        <div className={'ch-nav-lesson'}>
            <div className={'ch-nav-r-inner ch-nav-inner-compact'}>
                <div className={'ch-nav-lesson-title-wrapper'}>
                    {(!user.cmsMode && shortcutLocation === 'LESSON') &&
                        <h2 className="ch-nav-lesson-title">In this lesson</h2>
                    }
                    {smallScreenMode ? <Button type={'outline'} ref={closeButtonRef} onClick={() => closeNav()} aria-label={'Close'}><CrossIcon /></Button> : null}
                </div>
                <div className="ch-nav-shortcuts-body">
                    <nav aria-label={"Resource Navigation"} className={'ch-page-navigation ch-activity-navigation'} role={''}>
                        <PageMarkerNavigation indicatorPlacement="right" startOpen={user.cmsMode}/>
                        {showResources &&
                            <div className={'ch-list'}>
                                {user.cmsMode &&
                                    <CMSResourceNavigation shortcutLocation={shortcutLocation} />
                                }
                                {(!user.cmsMode && shortcutLocation === 'LESSON') &&
                                    <ResourceNavigationDevelopment key={shortcut.shortcutId} shortcut={shortcut} indicatorPlacement="right" resourceGroups={resourceGroups}/>
                                }
                            </div>
                        }
                    </nav>
                </div>
              </div>
        </div>
    );
}

export default NavigationRightDevelopment;